<template>
  <ValidationProvider :name="name" :rules="rules">
    <b-form-group
      class="h-form-group"
      :label="$attrs.label"
      :label-for="nameToSnakeCase"
    >
      <b-input-group :prepend="`${prepend}`" :append="`${append}`">
        <b-form-select
          class="select-input-field"
          v-bind="$attrs"
          :id="nameToSnakeCase"
          :name="name"
          @input="e => $emit('input', e)"
        />
      </b-input-group>
    </b-form-group>
    <div class="text-danger field-errors">
      <span v-for="err in $attrs.errors[name]" :key="err">
        {{ capitalizedError(err) }}
      </span>
    </div>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    name: String,
    rules: String,
    prepend: {
      type: String,
      default: ''
    },
    append: {
      type: String,
      default: ''
    }
  },
  methods: {
    capitalizedError(error) {
      if (error) {
        return error.charAt(0).toUpperCase() + error.slice(1);
      }
    }
  },
  computed: {
    nameToSnakeCase() {
      return this.name.replace(/\s/g, '_').toLowerCase()
    }
  }
}
</script>
